import { useEffect, useState } from "react";
import { ContainerScreenGeneral, Table } from "../../components";
import InputRangoFecha from "../../components/inputRangoFecha";
import AlertRecibosPagos from "../../views/Alerts/AlertRecibosPagos";
import useRecibosPagos from "../../api/recibosPagos";
import { useRecibosPagosStore } from "../../store/recibosPagosStore";
import { formatMoney } from "../../utils/formatMoney";
import { tableData } from "./tableData";

const RecibosPagos = () => {
  const { getRecibosPagos } = useRecibosPagos();
  const { montoTotal, recibos } = useRecibosPagosStore();

  const [filtros, setFiltros] = useState({
    fecha_desde: "",
    fecha_hasta: "",
    // localidad: "",
    // tipo: "",
    // search: ""
  });

  useEffect(() => {
    getRecibosPagos(filtros);
  }, [filtros]);
//   console.log(filtros);
//   console.log(recibos);

  return (
    <>
      <ContainerScreenGeneral titulo={"Recibos Pagos"} linkBack={"/"} size={"md"}>
        <div className="d-flex flex-column gap-3 p-4">
          <AlertRecibosPagos />
          <hr />
          <div className="d-flex align-items-center gap-5">
            <h5 className="m-0">Recibos</h5>
            <InputRangoFecha setFiltros={setFiltros} />
          </div>
          {/* {? ( */}
          {recibos && (
            <Table height={600} data={tableData(recibos, location)} name="actas" search />
          )}

          {/* ) : (
                        <p>No hay actas.</p>
                    )} */}
          <div className="d-flex gap-3">
            <h5>Monto total de los ultimos 30 días:</h5>
            <h5 className="m-0" style={{ color: "#198754" }}>
              {formatMoney(montoTotal)}
            </h5>
          </div>
          <div className="d-flex gap-3">
            <h5>Total de recibos pagos los ultimos 30 días:</h5>
            <h5 className="m-0" style={{ color: "#198754" }}>
              {recibos?.length}
            </h5>
          </div>
        </div>
      </ContainerScreenGeneral>
    </>
  );
};
export default RecibosPagos;
